module.exports = __webpack_public_path__ + "img/Add(Button).d547655c.svg";